import { FormSignupControllerImpl } from "../..";
import { ProfileUpdateResponse } from "../../../core";
import { ISubmitWithResponseStrategy } from "../../../core/strategies/CodeValidateStrategy";

export class ProfileCodeValidateStrategy implements ISubmitWithResponseStrategy {
    private controller = new FormSignupControllerImpl();
    private translate: any;

    constructor(translate: any) {
        this.translate = translate;
    }

    async execute(formData: FormData): Promise<ProfileUpdateResponse> {
        try {
            const response = await this.controller.profileUpdateCodeValidate(formData);
            if (response.success) {
                return response;
            } else {
                throw new Error(response?.error);
            }
        } catch (error) {
            throw error;
        }
    }
}